// extracted by mini-css-extract-plugin
export var standaloneTable = "_1r-0";
export var standaloneTableWithBodyFill = "_1r-1";
export var withExtraHeader = "_1r-2";